module.exports = __webpack_public_path__ + "static/media/smart-sparen-hero-mobil.fbf2c76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smart-sparen-hero-mobil.jpg
// module id = 344
// module chunks = 21